<template>
  <v-container fluid v-bind:style="{ maxWidth: '1200px' }">
    <v-layout flex align-center>
      <v-flex xs12 sm6 md4 offset-sm3 offset-md4>
        <v-card>
          <v-card-title primary-title>
            <h1 class="headline text-sm-center">Verifying e-mail</h1>
          </v-card-title>
          <v-card-text>
            <div class="text-sm-center">
              <v-progress-circular v-if="verifying" indeterminate color="primary"></v-progress-circular>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import swal from "sweetalert2"
import axios from "axios"
import { bugsnagClient } from "~/plugins"

export default {
  data: function() {
    return {
      verifying: true,
      verified: false,
      token: null
    }
  },
  mounted: async function() {
    this.token = this.$route.params.token
    if (this.$route.params.token === undefined) {
      this.verifying = false

      await swal({
        title: "No verification token provided",
        text:
          "Please click the link in the e-mail you got or as for support on our Slack channel.",
        showCloseButton: true,
        customClass: "swal-type-warning",
        imageUrl: "/img/popup_img_warning.png",
        imageHeight: 48,
        imageWidth: 48
      })

      this.$router.push("/")
    }

    try {
      let { data } = await axios.post("/api/v1/register/verify/" + this.token)

      await swal({
        showCloseButton: true,
        imageUrl: "/img/popup_img_login_success.jpg",
        imageHeight: 80,
        imageWidth: 80,
        imageAlt: "Verification succeeded",
        title: "Verification succeeded",
        html: "You can log in to your account right now!",
        customClass: "swal-login-register",
        confirmButtonText: "Log in"
      })

      this.$router.push("/login")
    } catch (error) {
      if (!error.response || error.response.status !== 422) {
        bugsnagClient.notify(error)
      }

      switch (error.response.data) {
        case "error_input":
          await swal({
            title: "Verification failed",
            text: "The verification token provided is invalid.",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          })

          this.$router.push("/")
          return
        case "error_expired":
          const result = await swal({
            title: "Verification failed",
            text:
              "The verification token has expired, shall we send a new one?",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          })

          if (result.value) {
            try {
              let { data } = await axios.post(
                "/api/v1/register/resend-verify/" + this.token
              )

              await swal({
                title: "New verification token send",
                text: "Please check your e-mail.",
                showCloseButton: true,
                imageUrl: "/img/popup_img_success.png",
                imageHeight: 80,
                imageWidth: 80,
                customClass: "swal-type-success",
              })
            } catch (error) {
              if (!error.response || error.response.status !== 422) {
                bugsnagClient.notify(error)
              }

              await swal({
                title: "Resending failed",
                text: "Please contact us on Slack.",
                showConfirmButton: false,
                showCloseButton: true,
                customClass: "swal-type-error",
                imageUrl: "/img/popup_img_error.png",
                imageHeight: 80,
                imageWidth: 80
              });
            }
          }

          this.$router.push("/")
      }
    }
  },
  methods: {
    verify: function() {}
  }
}
</script>


// WEBPACK FOOTER //
// resources/js/pages/auth/register-verify.vue